module.exports = __webpack_public_path__ + "arrow.svg?7fec0a71a6170abd11ddc9d0522ef59f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow.svg
// module id = 148
// module chunks = 2